class FiltersService {
  constructor(ApiService, FiltersSchema, Upload, $q) {
    this.ApiService = ApiService;
    this.FiltersSchema = FiltersSchema;
    this.$q = $q;
    this.Upload = Upload;
    this.filterEndpoint = '/api/locationfilters';
    this.imageEndpoint = '/api/upload';
  }

  getNew() {
    return this.FiltersSchema;
  }

  getById(id) {
    var self = this;
    return self.ApiService
      .get(self.filterEndpoint + '/' + id)
      .then(response => {
        return response.data;
      });
  }

  getAll() {
    var self = this;
    return self.ApiService.get('/api/locationfilters').then(response => {
      return response.data;
    });
  }

  reorder(filters) {
    var self = this;
    var ids = [];
    angular.forEach(filters, filter => {
      ids.push(filter.id);
    });

    return self.ApiService.patch(self.filterEndpoint, ids);
  }

  deleteFilter(filterId) {
    var self = this;
    return self.ApiService._delete(this.filterEndpoint + '/' + filterId);
  }

  addNew(filter, files) {
    var self = this;

    // save the icon
    return self.Upload
      .upload({
        url: self.imageEndpoint + '/icon',
        data: { file: files.icon }
      })
      .then(function(response) {
        // add icon details to filter object
        filter.iconImageUrl = response.data.image.url;

        return self.Upload
          .upload({
            url: self.imageEndpoint + '/pin',
            data: { file: files.pin }
          })
          .then(function(response) {
            // add pin details to filter object
            filter.pinImageUrl = response.data.image.url;

            return self.Upload
              .upload({
                url: self.imageEndpoint + '/home_location_filter',
                data: { file: files.home_location_filter }
              })
              .then(function(response) {
                // save the advert
                filter.featureImageUrl = response.data.image.url;
                return self.ApiService.post(self.filterEndpoint, filter);
              });
          });
      });
  }

  update(filter, files) {
    var self = this;
    filter = self.stripUnnecessaryFields(filter);

    self.filter = filter;

    // if there is an icon save it
    return self.saveIcon(files.icon).then(response => {
      // add icon details to filter object
      if (response) {
        self.filter.iconImageUrl = response.data.image.url;
      }

      // if there is a pin save it
      return self.savePin(files.pin).then(response => {
        // add pin details to filter object
        if (response) {
          self.filter.pinImageUrl = response.data.image.url;
        }
        return self.saveFeature(files.home_location_filter).then(response => {
          if (response) {
            self.filter.featureImageUrl = response.data.image.url;
          }
          return self.saveFilter();
        });
      });
    });
  }

  saveIcon(file) {
    var self = this;

    if (file) {
      return self.Upload
        .upload({
          url: self.imageEndpoint + '/icon',
          data: { file: file }
        })
        .catch(response => {
          var error = {
            type: 'image',
            field: 'icon',
            message: 'Unknown error saving the Filter icon'
          };
          if (response.data.error) {
            error.message = response.data.message;
          }
          return self.$q.reject(error);
        });
    } else {
      return self.$q.when(null);
    }
  }

  savePin(file) {
    var self = this;

    if (file) {
      return self.Upload
        .upload({
          url: self.imageEndpoint + '/pin',
          data: { file: file }
        })
        .catch(response => {
          var error = {
            type: 'image',
            field: 'pin',
            message: 'Unknown error saving the Filter pin'
          };
          if (response.data.error) {
            error.message = response.data.message;
          }
          return self.$q.reject(error);
        });
    } else {
      return self.$q.when(null);
    }
  }

  saveFeature(file) {
    var self = this;

    if (file) {
      return self.Upload
        .upload({
          url: self.imageEndpoint + '/home_location_filter',
          data: { file: file }
        })
        .catch(response => {
          var error = {
            type: 'image',
            field: 'feature',
            message: 'Unknown error saving the Filter feature image'
          };
          if (response.data.error) {
            error.message = response.data.message;
          }
          return self.$q.reject(error);
        });
    } else {
      return self.$q.when(null);
    }
  }

  saveFilter() {
    var self = this;
    // save the filter
    return self.ApiService.put(
      self.filterEndpoint + '/' + self.filter.id,
      self.filter
    );
  }

  stripUnnecessaryFields(filter) {
    var newObj = {
      id: filter.id,
      name: filter.name,
      pinImageUrl: filter.pinImageUrl,
      iconImageUrl: filter.iconImageUrl,
      featureImageUrl: filter.featureImageUrl,
      active: filter.active
    };
    return newObj;
  }
}
FiltersService.$inject = ['ApiService', 'FiltersSchema', 'Upload', '$q'];
export default FiltersService;
